var map = {
	"./anchorage.svg": 174,
	"./beach.svg": 173,
	"./boatramp.svg": 184,
	"./boatyard.svg": 185,
	"./cave.svg": 175,
	"./fishingarea.svg": 180,
	"./marina.svg": 177,
	"./mooring.svg": 176,
	"./port.svg": 178,
	"./seaplaneport.svg": 183,
	"./shipyard.svg": 181,
	"./transitional_anchorage.svg": 182,
	"./wreck.svg": 179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 704;